enum Network {
  BSC = 'bsc',
  ETH = 'eth',
  POLYGON = 'polygon'
}

export default Network
